var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteBoxWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete_box_white",
    transform: "translate(-411 -376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2540",
    "data-name": "Rectangle 2540",
    transform: "translate(411 376)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(421.004 385.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M222.836,154.7a.438.438,0,0,0-.438.438v8.282a.438.438,0,0,0,.876,0v-8.282A.438.438,0,0,0,222.836,154.7Zm0,0",
    transform: "translate(-212.656 -147.925)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M104.836,154.7a.438.438,0,0,0-.438.438v8.282a.438.438,0,1,0,.876,0v-8.282a.438.438,0,0,0-.438-.438Zm0,0",
    transform: "translate(-99.826 -147.925)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M1.241,5.569v10.8a2.418,2.418,0,0,0,.643,1.667,2.158,2.158,0,0,0,1.566.677h8.291a2.157,2.157,0,0,0,1.566-.677,2.418,2.418,0,0,0,.643-1.667V5.569a1.674,1.674,0,0,0-.429-3.292H11.276V1.729A1.721,1.721,0,0,0,9.541,0H5.65A1.721,1.721,0,0,0,3.914,1.729v.548H1.671a1.674,1.674,0,0,0-.429,3.292Zm10.5,12.264H3.45a1.388,1.388,0,0,1-1.332-1.468V5.607H13.073V16.365a1.388,1.388,0,0,1-1.332,1.468Zm-6.95-16.1A.844.844,0,0,1,5.65.875H9.541a.844.844,0,0,1,.859.854v.548H4.791ZM1.671,3.154H13.52a.789.789,0,0,1,0,1.578H1.671a.789.789,0,0,1,0-1.578Zm0,0",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M163.836,154.7a.438.438,0,0,0-.438.438v8.282a.438.438,0,0,0,.876,0v-8.282a.438.438,0,0,0-.438-.438Zm0,0",
    transform: "translate(-156.241 -147.925)",
    fill: "gray"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBoxWhite);
export default __webpack_public_path__ + "static/media/delete_box_white.2b3ff0b430627cdc08aa6168c60f014d.svg";
export { ForwardRef as ReactComponent };